"use strict";
module.exports = function (app) {
    app.directive('vmViewPortHelper', function ($window, $timeout){
        return {
            scope: {
                'products' : "=",
                'indexDisplayProduct': '='
            },
            restrict: "A",
            link: function (scope, iElement, iAttrs) {
                function updateProductsSlider(event, products) {
                    var window = $($window);
                    var originalArr;
                    var preStartedProduct;
                    var windowSize;
                    var counter = 0; //counter for function run times

                    function trimProductsArray(products, displayNumber) {
                        //run when first time function run
                        if ( counter === 0 ) {
                            if ( products && products.length > 5 ) {
                                originalArr = trim(products, 5).slice();
                            } else {
                                originalArr = products;
                            }
                        }

                        var startedProduct = products
                            .filter(function (p) {
                                return p.started === true;
                            });

                        /* @return new array after trim the products array*/
                        function trim(products, displayNumber) {

                                var indexDisplayProduct = products
                                    .map(function (p)
                                     {
                                         return p.started;
                                     }).indexOf(true);
                            //find middle product if there is not product started
                            indexDisplayProduct = indexDisplayProduct === -1 ? Math.round((products.length - 1) / 2): indexDisplayProduct ;

                            if (products.length > displayNumber && indexDisplayProduct >= 0 && displayNumber % 2 !== 0) {
                                var arrLength = products.length;
                                var headIndexNewArr = indexDisplayProduct - Math.floor(displayNumber / 2);
                                var tailIndexNewArr = indexDisplayProduct + Math.floor(displayNumber / 2);
                                products.splice(0, headIndexNewArr);
                                products.splice(tailIndexNewArr - headIndexNewArr + 1, arrLength - tailIndexNewArr - 1);
                                return products.slice();
                            }

                            if (displayNumber === 2) {
                                products.splice(0, indexDisplayProduct);
                                products.splice(2, products.length - 2);
                                return products.slice();
                            }
                        }

                        //update previous product
                        if (preStartedProduct === undefined || (preStartedProduct && preStartedProduct.products_id !== startedProduct.products_id)) {
                            preStartedProduct = startedProduct;
                        }

                        //update counter
                        counter++;

                        if (products.length > displayNumber) {
                            return trim(products, displayNumber);
                        } else {
                            return products.slice();
                        }
                    }

                    function displayProductsNum(products) {
                        var width = window.width();
                        var trimedProducts;
                        var indexDisplayProduct;

                        function findIndexTrimedArray(trimedProducts) {
                            return trimedProducts.findIndex(function (product) {
                                return product.started === true;
                            });
                        }

                        if (width >= 1200) {
                            windowSize = 'lg';
                            trimedProducts = trimProductsArray(products, 5);
                            indexDisplayProduct =  findIndexTrimedArray(trimedProducts);
                        }
                        else if (width >= 992 && width < 1200) {
                            windowSize = 'md';
                            trimedProducts = trimProductsArray(products, 5);
                            indexDisplayProduct =  findIndexTrimedArray(trimedProducts);
                        }
                        else if (width >= 480 && width < 992) {
                            windowSize = 'sm';
                            trimedProducts = trimProductsArray(products, 3);
                            indexDisplayProduct =  findIndexTrimedArray(trimedProducts);
                        }
                        else if (width < 480) {
                            windowSize = 'xs';
                            trimedProducts = trimProductsArray(products, 2);
                            indexDisplayProduct =  findIndexTrimedArray(trimedProducts);
                        }

                        return {
                            trimedProducts: trimedProducts,
                            indexDisplayProduct: indexDisplayProduct
                        };
                        // return trimedProducts;
                    }

                    window.bind('resize', function () {
                        $timeout(function () {
                            var products = originalArr.slice();
                            var computedDisplayProducts = displayProductsNum(products);
                            scope.products = computedDisplayProducts.trimedProducts;
                            scope.$parent.$parent.indexDisplayProduct = computedDisplayProducts.indexDisplayProduct;
                        }, 200);
                    });

                    var computedDisplayProducts = displayProductsNum(products);

                    scope.products = computedDisplayProducts.trimedProducts;
                    scope.$parent.$parent.indexDisplayProduct = computedDisplayProducts.indexDisplayProduct;
                }

                //this always run firstly before the resize event
                scope.$on('products:loaded', updateProductsSlider);
            }
        };
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./dash_board/js/view_port_helper.directive.js
 ** module id = 42
 ** module chunks = 0
 **/